import React from "react";
import { observer } from "mobx-react-lite";
import WrapperPage from "../../components/WrapperPage";
import Ellipses from "../../components/Ellipses";
import BaseButton from "../../components/BaseButton";
import StaticCardActionBtn from "../../components/StaticCardActionBtn";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../utils/routes.js";
import Game from "../../store/Game";
import PersonalAccount from "../../store/PersonalAccount";
import { CURRENT_GAME_KEY } from "../../utils/constants";
// Раскладка идентична экрану «/meet» (Figma 4250-17764) — переиспользуем его стили.
import "../MeetPage/style.scss";

// Task 4 (Figma 4250-17764 web / 4250-17763 моб): инструкция к +57 как ПОЛНОЦЕННАЯ
// СТРАНИЦА (была модалка — там одиночная кнопка съезжала влево). Раскладка «/meet»
// (WrapperPage + неон-титл + легенда ✓/?/✕ + центрированная кнопка), контент/текст +57
// сохранён. «Далее» → свайпер +57 (setType EXTENDED_57). gameId приходит через state.
const Extended57InstructionPage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const gameId = location.state?.gameId;

  const goExtended = () => {
    const eventGame = PersonalAccount.games?.find((g) => g.id === gameId);
    if (eventGame) {
      Game.setGame(eventGame);
      localStorage.setItem(CURRENT_GAME_KEY, JSON.stringify(eventGame));
    }
    navigate(ROUTES.IN_GAME_PAGE, {
      state: { setType: "EXTENDED_57", gameId },
    });
  };

  return (
    <div className="meet-wrapper centering-page">
      <Ellipses countEllipses={1} className="meet-wrapper-ellipses" />
      <WrapperPage
        headerTitle={t("extended57.instruction.title")}
        backBtn
        burgerMenu
      >
        <div className="meet-wrapper__description">
          <p>{t("extended57.instruction.p1")}</p>
          <br />
          <p>{t("extended57.instruction.p2")}</p>
          <br />
          <p>{t("extended57.instruction.p3")}</p>
        </div>
        <div className="meet-wrapper__answers">
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="positive" />
            <p className="meet-wrapper__answer__text">
              {t("extended57.instruction.like")}
            </p>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="neutral" />
            <p className="meet-wrapper__answer__text">
              {t("extended57.instruction.unsure")}
            </p>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="negative" />
            <p className="meet-wrapper__answer__text">
              {t("extended57.instruction.dislike")}
            </p>
          </div>
        </div>
        <div className="meet-wrapper__answers-mobile">
          <div className="meet-wrapper__answers-mobile-top">
            <div className="meet-wrapper__answer">
              <StaticCardActionBtn type="positive" />
              <p className="meet-wrapper__answer__text">
                {t("extended57.instruction.like")}
              </p>
            </div>
            <div className="meet-wrapper__answer">
              <StaticCardActionBtn type="negative" />
              <p className="meet-wrapper__answer__text">
                {t("extended57.instruction.dislike")}
              </p>
            </div>
          </div>
          <div className="meet-wrapper__answer">
            <StaticCardActionBtn type="neutral" />
            <p className="meet-wrapper__answer__text">
              {t("extended57.instruction.unsure")}
            </p>
          </div>
        </div>
        <BaseButton onClick={goExtended} className="meet-wrapper__btn-go">
          {t("extended57.instruction.next")}
        </BaseButton>
      </WrapperPage>
    </div>
  );
});

export default Extended57InstructionPage;
